import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-consignment-shipment',
  templateUrl: './consignment-shipment.component.html',
  styleUrls: ['./consignment-shipment.component.css']
})
export class ConsignmentShipmentComponent implements OnInit {
    public consignmentShipmentKeyno;

    stockPlaceId;

    public edit?: Edit;

    public saving = false;

    public deleting = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.consignmentShipmentKeyno = this.stateService.getStateParams()['consignmentshipment_keyno'];
        this.stockPlaceId = this.stateService.getStateParams()['stockplace_id'];
    }

    private async loadEdit() {
        if (!!this.consignmentShipmentKeyno && !!this.stockPlaceId) {
            this.edit = (await this.datatask.Post(1104, {
                consignmentshipment_keyno: this.consignmentShipmentKeyno,
                stockplace_id: this.stockPlaceId
            }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(1105, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    public async deleteValues() {
        if (!!this.edit) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    const response = (await this.datatask.Post(1106, this.edit))[0];

                    if (response.errorcode !== '0') {
                        this.modal.show({
                            type: 'warning',
                            title: 'error',
                            message: response.errormessage
                        });
                    } else {
                        this.stateService.back();
                    }
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    consignmentshipment_keyno: string;
    consignmentshipment_name: string;
    planned_shipping_dt: string;
    isshipped: string;
    actual_shipping_dt: string;
    reg_by_portal_user_name: string;
    shipped_by_portal_user_name: string;
    reg_datetime: string;
    isplanned: string;
    stockplace_id: string;
    stockplace_name: string;
    agreement_note: string;
    estimated_arrival_dt: string;
    show_setting: string;
    transcarrier_keyno: string;
}
